import type { ButtonHTMLAttributes, HTMLAttributes } from "react";

import type { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const PAGINATION_ELLIPSIS_START = "ellipsis-start";

export const PAGINATION_ELLIPSIS_END = "ellipsis-end";

export const PAGINATION_NAV_CLASS = "mx-auto flex w-full justify-center";

export const PAGINATION_LIST_CLASS = "flex flex-row items-center gap-1";

export const PAGINATION_LINK_BASE_CLASS = "inline-flex h-10 min-w-10 items-center justify-center gap-1 rounded-sys-md px-2 text-foreground transition-colors hover:bg-surface-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:pointer-events-none disabled:text-foreground-muted";

export const PAGINATION_LINK_ACTIVE_CLASS = "bg-surface-inverse text-foreground-inverse hover:bg-surface-inverse";

export const PAGINATION_ELLIPSIS_CLASS = "inline-flex h-10 min-w-10 items-center justify-center text-foreground";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TPaginationRangeItem =
  | number
  | typeof PAGINATION_ELLIPSIS_START
  | typeof PAGINATION_ELLIPSIS_END;

export type TPaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  /** Page buttons shown on each side of the current page; the rest collapse into ellipses. */
  siblingCount?: number;
} & Omit<HTMLAttributes<HTMLElement>, "onChange">;

export type TPaginationLinkProps = {
  isActive?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

type TPaginationDefaultProps = DefinedDefaults<TPaginationProps, "siblingCount">;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const PAGINATION_DEFAULTS = {
  siblingCount: 1,
} satisfies TPaginationDefaultProps;
